import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import Swal from 'sweetalert2'
import _ from 'underscore'
import __ from 'lodash'
import { Button, ListGroupItem, ListGroup, Col, Row } from 'react-bootstrap'
import { Collapse } from 'reactstrap'
import { showInfo, addToCart } from './actions'
import { fetchMainServices, getServiceChildren, getParentServices } from '../../../catalogue'
import CustomSubServices from './customSubService'
import { switchCheckoutContent } from '../checkoutContent/actions'
import { showModal, searchServices, fetchAdditionalServices, switchAppointmentOrBudget } from './actions'
import AppointmentOrBudget from './../appointment/appointmentOrBudget.component'

import Observations from './observations.component'
import uuid from 'uuid'

import { configuration } from '../../../configuration'
import './styles.css'

const BLANK_BUDGET_LINE = 'BLANK_BUDGET_LINE';

class Services extends Component {
  static propTypes = {
    showInfo: PropTypes.func,
    services: PropTypes.shape({
      selectedService: PropTypes.number,
    }),
    onClick: PropTypes.func,
    buttonTextArrow: PropTypes.oneOfType([PropTypes.string, PropTypes.element]),
    buttonText: PropTypes.string,
    status: PropTypes.string, // Used in newAppointmentData
    car: PropTypes.shape({ // This is used to render the service price based on the cars[] in the service model
      make: PropTypes.string,
      model: PropTypes.string,
      engine: PropTypes.string,
      year: PropTypes.number,
    })
  };

  static defaultProps = {
    buttonText: '',
    buttonTextArrow: <React.Fragment><span className="labelFlip1">SIGUIENTE</span> <span className="labelFlip2" style={{ visibility: 'hidden' }}>SIGUIENTE</span> {configuration().clientColor ? <i className="fa fa-angle-right" aria-hidden="true"></i> : ''}</React.Fragment>,
  }

  state = {
    otherServiceName: '',
    otherServicePrice: '',
    serviceSearch: "",
    renderAppointmentOrBudget: false,
  }
  handleChange = name => event => {
    this.setState({
      [name]: event.target.value,
    });
  };
  cleanOtherService() {
    this.setState({
      otherServiceName: '',
      otherServicePrice: '',
    });
  }

  componentWillMount() {
    this.props.fetchAdditionalServices();
  }

  componentDidMount() {
    this.props.fetchMainServices(this.props.car);
  }

  componentWillReceiveProps(props) {
    if (this.state.renderAppointmentOrBudget !== props.fetchMainServicesrenderAppointmentOrBudget) {
      this.setState({
        renderAppointmentOrBudget: props.renderAppointmentOrBudget,
      })
    }

    if (this.props.catalogue.additionalServices === false) {
      this.props.fetchAdditionalServices();
    }
  }

  addAdditionalData = () => {
    this.props.showModal(true);
  }

  renderCustomServices = () => {
    return (
      <CustomSubServices></CustomSubServices>
    )
  }

  back() {
    this.props.fetchMainServices(this.props.car)
  }

  addToCart(element) {
    this.cleanOtherService()
    if (_.some(this.props.shoppingCart.items, e => e.serviceId === element.serviceId)) {
      Swal.fire({
        title: 'Oops',
        text: 'Parece que ya ha añadido ese servicio',
        type: 'error'
      });
    } else {
      if (element.serviceId === 'serviciochapaypintura') {
        this.addAdditionalData();
      }
      if (element.name === BLANK_BUDGET_LINE) {
        element.name = this.state.otherServiceName
        element.price = this.state.otherServicePrice / configuration().ivaConfigTaxesSin;
        element.ivaPrice = this.state.otherServicePrice * configuration().ivaConfigTaxesCon;
        element.serviceId = uuid.v4();
        element._id = null;
      }
      this.props.addToCart(element, this.props.currentMake, this.props.car);
    }
  }

  next = () => {
    console.log("NEXT")
    if (this.props.shoppingCart.forfait) {
      this.props.switchAppointmentOrBudget(false)
      this.setState({
        renderAppointmentOrBudget: false
      })
      this.props.switchCheckoutContent('appointment');
    } else {
      this.props.switchAppointmentOrBudget(true)
      this.setState({
        renderAppointmentOrBudget: true
      })
    }
  }

  render() {
    let rawServices = this.props.catalogue.services;
    let scene = null;
    const checkService = function (serviceId) {
      return this.props.services.selectedService === serviceId;
    }.bind(this);

    if (this.state.renderAppointmentOrBudget === true) {
      scene = <AppointmentOrBudget />
    } else if (this.props.services.router === 'content') {
      const services = rawServices.sort(x => x.selectable ? 1 : -1).sort((a, b) => a.order - b.order)
      scene = (
        <React.Fragment>
          <div id="serviceContainer">
            <ListGroup>
              {
                (services.filter((e) => !e.isAdditional)).map((service, key) => {
                  if (!this.props.catalogue.customService && service.selectable) {
                    let renderAdd = <button href="javascript:void(0);"
                      className="jump set-hover-button custom-add-button"
                      style={{
                        borderColor: configuration().clientColor
                      }}
                      onClick={() => this.addToCart(service, this.props.currentMake, this.props.car)}>
                      <span
                        className="labelFlip1 span-add"
                        style={{ color: configuration().clientColor }}
                      >
                        AÑADIR
                                      </span>
                      <span className="labelFlip2" style={{ visibility: 'hidden' }}>AÑADIR</span>
                    </button>

                    /* BEGIN RETRIEVE ENGINE PRICE VALUE */
                    const car = this.props.car || {};
                    const currentMake = this.props.currentMake || { models: { engines: {} } };
                    const isCarsArrayWithLength = Array.isArray(service.cars) && service.cars.length > 0
                    // const isCarANonEmptyObject = Object.keys(car).length > 0;

                    const matchedCarMake = __.find(service.cars, { reference: currentMake.models.engines.engineId }) || {}
                    if (
                      isCarsArrayWithLength
                      && Object.keys(matchedCarMake).length > 0
                    ) {
                      if (!matchedCarMake.price) {
                        renderAdd = <Button disabled={true} className="custom-add-button__disabled">AÑADIR</Button>
                      }
                    }

                    return (
                      (service.name === BLANK_BUDGET_LINE)
                        ? null
                        :
                        <ListGroupItem key={key}>
                          <div style={{ cursor: 'pointer' }} onClick={() => this.props.showInfo(key)}>
                            <span>
                              {configuration().customServiceIcons
                                ? service.icon && <img src={"/images/" + configuration().brandName + service.icon} width="28" style={{ marginRight: "15px" }} />
                                : service.icon && <img src={"/images/" + service.icon} width="28" style={{ marginRight: "15px" }} />}
                              <div style={{ display: 'flex', alignItems: 'center' }}>
                                <div>
                                  {renderAdd}
                                </div>
                                <div style={{ paddingLeft: '10px', paddingRight: '10px' }}>
                                  {service.name}
                                </div>
                              </div>

                              <span className="pull-right arrow-icon-bottom-up">{checkService(key) ? '' : ''}</span>
                              <Collapse isOpen={checkService(key)}>
                                <div style={{ marginTop: 5 }} className="info">
                                  <p dangerouslySetInnerHTML={{ __html: service.description }} />
                                </div>
                              </Collapse>
                            </span>
                          </div>
                        </ListGroupItem>
                    )
                  } else if (!this.props.catalogue.customService) {
                    return (
                      <ListGroupItem key={key}>
                        <div style={{ cursor: 'pointer' }} onClick={() => this.props.getServiceChildren(service, this.props.car, this.props.checkout.carData.clientCarPlate, configuration().workshopEmailHash)}>
                          <div className={service.loadFromIntegration && this.props.catalogue.loading ? 'loadingFromIntegration' : null}></div>
                          <span style={{ position: 'relative', display: 'flex', alignItems: 'center' }}>
                            {configuration().customServiceIcons
                              ? service.icon && <img src={"/images/" + configuration().brandName + service.icon} width="28" style={{ marginRight: "15px" }} />
                              : service.icon && <img src={"/images/" + service.icon} width="28" style={{ marginRight: "15px" }} />}
                            {service.name}
                            <span style={{ position: 'absolute', right: '0', top: '3px' }} className="pull-right arrow-icon-right"></span>
                          </span>
                        </div>
                      </ListGroupItem>
                    )
                  }
                })
              }
              {
                this.props.catalogue.customService ? this.renderCustomServices() : null
              }
            </ListGroup>
            <Row>
              {this.props.catalogue.customService ?
                <Col md={3}>
                  <button className=" responsivebutton jump pull-left button-secondary router-buttons" onClick={() => this.back(this.props.car)}>{configuration().arrowInButon ? <i className="fa fa-angle-left" aria-hidden="true"></i> : ''}
                    <span className="labelFlip1">ATRÁS</span> <span className="labelFlip2" style={{ visibility: 'hidden' }}>ATRÁS</span></button>
                </Col>
                :
                <Col md={3}>
                  <button className=" responsivebutton jump pull-left button-secondary router-buttons" disabled={!this.props.catalogue.history.length} onClick={() => this.props.getParentServices(this.props.catalogue.history, this.props.car)}>{configuration().arrowInButon ? <i className="fa fa-angle-left" aria-hidden="true"></i> : ''}
                    <span className="labelFlip1">ATRÁS</span> <span className="labelFlip2" style={{ visibility: 'hidden' }}>ATRÁS</span></button>
                </Col>
              }
              <Col md={3} className="offset-md-6">
                {this.props.shoppingCart.items.length !== 0 && this.props.status !== "NewAppointment"
                  && <button
                    className="responsivebutton jump pull-right blue-button-active"
                    disabled={this.props.shoppingCart.items.length === 0}
                    style={{
                      backgroundColor: configuration().clientColor,
                      borderColor: configuration().clientColor
                    }}
                    onClick={this.props.onClick || this.next}>{this.props.buttonText || this.props.buttonTextArrow}
                  </button>
                }
              </Col>
            </Row>
          </div>
        </React.Fragment>
      );

    } else if (this.props.services.router === 'observations') {
      scene = <Observations />;
    }
    return (

      <div className="bubocar-additional-service-box">
        {!this.props.services.isLoading
          ? scene
          : <span>Loading...</span>
        }
      </div>
    );
  }
}

const mapStateToProps = state => ({
  services: state.checkout.servicesData,
  catalogue: state.catalogue,
  checkout: state.checkout,
  shoppingCart: state.checkout.shoppingCart,
  modal: state.checkout.servicesData.modal.show,
  currentMake: state.make.currentMake,
  renderAppointmentOrBudget: state.checkout.servicesData.renderAppointmentOrBudget,
})

const bindActions = dispatch => ({
  addToCart: (element, makeObject, car) => dispatch(addToCart(element, makeObject, car)),
  getParentServices: (history, car) => dispatch(getParentServices(history, car)),
  showInfo: service => dispatch(showInfo(service)),
  fetchMainServices: (car) => dispatch(fetchMainServices(car)),
  getServiceChildren: (service, car, carPlate, emailHash) => dispatch(getServiceChildren(service, car, carPlate, emailHash)),
  switchCheckoutContent: content => dispatch(switchCheckoutContent(content)),
  showModal: (show) => dispatch(showModal(show)),
  fetchAdditionalServices: () => dispatch(fetchAdditionalServices()),
  searchServices: query => dispatch(searchServices(query)),
  switchAppointmentOrBudget: (renderAppointmentOrBudget) => dispatch(switchAppointmentOrBudget(renderAppointmentOrBudget)),
})

export default connect(mapStateToProps, bindActions)(Services)



// WEBPACK FOOTER //
// ./src/workflow/checkout/services/index.js